import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=744b5440&scoped=true&"
import script from "./SaleTable.vue?vue&type=script&lang=js&"
export * from "./SaleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b5440",
  null
  
)

export default component.exports